/**
 * Application entry point.
 *
 * Mounts <App /> inside a HashRouter. HashRouter (rather than BrowserRouter) is
 * used so the app can be served from a static host without server-side rewrite
 * rules -- every route lives after the '#' and never hits the server.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// React 18 concurrent-mode root, bound to <div id="root"> in public/index.html.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <App />
  </Router>
  // StrictMode is intentionally disabled: it double-invokes effects in
  // development, which fires the chart/data-fetch effects twice.
  // <React.StrictMode>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
